import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _parseInt from "@babel/runtime-corejs3/core-js-stable/parse-int";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useMemo } from 'react';
import Box from '@rexlabs/box';
import { useToken, useStyles, StyleSheet, padding, mq } from '@rexlabs/styling';
import { Toast } from './core';
import { useToast } from './context';
var targetStyles = StyleSheet({
  container: _objectSpread(_objectSpread({
    position: 'fixed',
    right: 0,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    pointerEvents: 'none'
  }, padding.styles({
    target: 'toast.target',
    all: 'm'
  })), {}, {
    zIndex: function zIndex(_ref) {
      var token = _ref.token;
      return token('toast.target.zIndex', _parseInt(token('zIndex.base', 0)) + 30);
    },
    '& > *': {
      pointerEvents: 'all'
    }
  }),
  top: {
    top: 0,
    flexDirection: 'column-reverse'
  },
  bottom: {
    bottom: 0,
    flexDirection: 'column'
  },
  left: _objectSpread({
    alignItems: 'flex-start'
  }, mq.styles({
    queries: {
      maxWidth: 's'
    },
    styles: {
      alignItems: 'center'
    }
  })),
  right: _objectSpread({
    alignItems: 'flex-end'
  }, mq.styles({
    queries: {
      maxWidth: 's'
    },
    styles: {
      alignItems: 'center'
    }
  }))
});

function ToastTarget(_ref2) {
  var _ref2$name = _ref2.name,
      name = _ref2$name === void 0 ? 'main' : _ref2$name,
      _ref2$position = _ref2.position,
      position = _ref2$position === void 0 ? 'top-right' : _ref2$position;
  var s = useStyles(targetStyles);
  var token = useToken();

  var _useToast = useToast(),
      allToasts = _useToast.toasts;

  var toasts = useMemo(function () {
    return _filterInstanceProperty(allToasts).call(allToasts, function (toast) {
      return toast.target === name;
    });
  }, [allToasts, name]);

  var top = _includesInstanceProperty(position).call(position, 'top');

  var bottom = _includesInstanceProperty(position).call(position, 'bottom');

  var left = _includesInstanceProperty(position).call(position, 'left');

  var right = _includesInstanceProperty(position).call(position, 'right');

  var spacing = token('toast.target.spacing', token('spacing.m'));
  return toasts.length ? /*#__PURE__*/React.createElement(Box, _extends({}, s('container', {
    top: top,
    bottom: bottom,
    left: left,
    right: right
  }), {
    sy: spacing
  }), _mapInstanceProperty(toasts).call(toasts, function (toast, index) {
    return /*#__PURE__*/React.createElement(Toast, _extends({
      key: toast.id
    }, toast, {
      timerEnabled: index === 0
    }));
  })) : null;
}

export default ToastTarget;